import { apiClient } from '@/api/axios';

export interface ReminderNotificationConfig {
  enabled: boolean;
  channels: ('in-app' | 'email' | 'sms')[];
  timing: ('at-time' | '1-day-before' | '3-days-before' | 'custom')[];
  customDays?: number;
}

export interface ApiReminder {
  id: string;
  title: string;
  category: string;
  platform: string;
  userClerkId: string;
  petId?: string;
  animalId?: string;
  clientId?: string;
  date: string;
  time: string;
  repeat: string;
  customRepeatDays?: number;
  priority: string;
  status: string;
  notes?: string;
  isInternal?: boolean;
  autoGenerated?: boolean;
  linkedAppointmentId?: string;
  linkedRecordId?: string;
  notifications: ReminderNotificationConfig;
  snoozedUntil?: string;
  completedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export const remindersApi = {
  async list(params?: Record<string, any>) {
    const { data } = await apiClient.get<{ items: ApiReminder[]; total: number }>('/reminders', { params });
    return data;
  },

  async create(body: Partial<ApiReminder>) {
    const { data } = await apiClient.post<ApiReminder>('/reminders', body);
    return data;
  },

  async update(id: string, body: Partial<ApiReminder>) {
    const { data } = await apiClient.patch<ApiReminder>(`/reminders/${id}`, body);
    return data;
  },

  async complete(id: string) {
    const { data } = await apiClient.patch<ApiReminder>(`/reminders/${id}/complete`);
    return data;
  },

  async snooze(id: string, until: string) {
    const { data } = await apiClient.patch<ApiReminder>(`/reminders/${id}/snooze`, { until });
    return data;
  },

  async remove(id: string) {
    await apiClient.delete(`/reminders/${id}`);
  },
};
